import React, { JSX } from 'react'
import FormFieldFromProps from '@Fields/v2/FormFieldFromProps'
import { FormFieldType } from '@App/forms/v2/common/form-field'

interface IdentifiersSectionProps {
    hfaPublisherNumber?: FormFieldType<string>
    ipiNumber?: FormFieldType<string>
    isni?: FormFieldType<string>
    identifierToolTip?: JSX.Element
}

const IdentifiersSection = (props: IdentifiersSectionProps) => {
    const { hfaPublisherNumber, ipiNumber, isni, identifierToolTip } = props

    return (
        <div className="identifiers-section">
            <h5>
                Identifiers
                {identifierToolTip}
            </h5>
            {hfaPublisherNumber && <FormFieldFromProps field={hfaPublisherNumber} />}
            {ipiNumber && <FormFieldFromProps field={ipiNumber} />}
            {isni && <FormFieldFromProps field={isni} />}
        </div>
    )
}

export default IdentifiersSection
